import * as React from "react";
import { SizedActionButton } from "../../actionButton/ActionButton";
import { ITableAction } from "../../../types/ITableAction";
import { formatDateToHourAndMinutes } from "../../../../membersportal/util/dateHelpers";
import { ADD_COVER_VERSION_ACTION } from "../../../../membersportal/Consts";
import {
    ADD_NEW_ACTION,
    ADD_NEW_DATE_ACTION,
    COPY_ACTION,
    SEARCH_ACTION,
    TABLE_ACTIONS_INSTANCE_KEY,
} from "../../../Consts";

interface IDataGridTableField {
    componentInstance: string;
    name: string;
    data: string;
}

interface IDataGridTableData {
    fields: IDataGridTableField[];
}

export interface IRenderTableActionParams {
    tableAction: ITableAction;
    index: number;
    componentInstance: string;
    dataGridTableData: IDataGridTableData;
    isReadOnly?: boolean;
    openWorkFlow?: boolean;
    tableContents?: any[];
    onClickAdd: () => void;
    onClickCopy?: () => void;
    showSearchModal: (modalProps: any, searchViewKey: string, index?: number) => void;
}

const getTableActionButtonText = (
    dataGridTableData: IDataGridTableData,
    actionName: string
): string => {
    const field = dataGridTableData?.fields?.find(
        f =>
            f.componentInstance === TABLE_ACTIONS_INSTANCE_KEY &&
            f.name === actionName
    );

    return field?.data ?? "";
};

export const renderTableAction = ({
    tableAction,
    index,
    componentInstance,
    dataGridTableData,
    isReadOnly,
    openWorkFlow,
    tableContents,
    onClickAdd,
    onClickCopy = () => { },
    showSearchModal,
}: IRenderTableActionParams): JSX.Element | null => {
    switch (tableAction.name) {
        case ADD_NEW_ACTION: {
            return (
                <SizedActionButton
                    key={index}
                    buttonText={getTableActionButtonText(dataGridTableData, ADD_NEW_ACTION)}
                    buttonAction={onClickAdd}
                    disabled={tableAction.disabled || isReadOnly}
                />
            );
        }

        case COPY_ACTION: {
            const isThereAtLeastOneCopyCheckBoxSelected =
                tableContents &&
                tableContents.length > 0 &&
                tableContents.find(line => line && line?.copySection?.value);

            return (
                <SizedActionButton
                    key={index}
                    buttonText={getTableActionButtonText(dataGridTableData, COPY_ACTION)}
                    buttonAction={onClickCopy}
                    disabled={tableAction.disabled || isReadOnly || !isThereAtLeastOneCopyCheckBoxSelected}
                />
            );
        }

        case ADD_COVER_VERSION_ACTION: {
            return (
                <SizedActionButton
                    key={index}
                    buttonText={getTableActionButtonText(dataGridTableData, ADD_COVER_VERSION_ACTION)}
                    buttonAction={onClickAdd}
                    disabled={tableAction.disabled || isReadOnly}
                />
            );
        }

        case ADD_NEW_DATE_ACTION: {
            return (
                <SizedActionButton
                    key={index}
                    buttonText={formatDateToHourAndMinutes(
                        getTableActionButtonText(dataGridTableData, ADD_NEW_DATE_ACTION)
                    )}
                    buttonAction={onClickAdd}
                    disabled={tableAction.disabled || isReadOnly}
                />
            );
        }

        case SEARCH_ACTION: {
            return (
                <SizedActionButton
                    key={index}
                    buttonText={getTableActionButtonText(dataGridTableData, SEARCH_ACTION)}
                    buttonAction={() => showSearchModal(null, componentInstance)}
                    disabled={tableAction.disabled || isReadOnly || openWorkFlow}
                />
            );
        }

        default: {
            return null;
        }
    }
};